export class FileUtilities {
  async fileToBase64(file) {
    const reader = new window.FileReader();
    const dataURL = await new Promise(resolve => {
      reader.onload = e => resolve(e.target.result);
      reader.readAsDataURL(file);
    });
    return dataURL;
  }
  createBlobData(file, type) {
    const bytes = file.split(",")[1];
    const binary = window.atob(bytes);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new window.Blob([new Uint8Array(array)], {
      type
    });
  }
}
const fileUtilities = new FileUtilities();
export default fileUtilities;